var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"playing-form-layout",on:{"click":_vm.hideForm}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"playing-form"},[_c('div',{staticClass:"playing-form_text"},[_vm._v(" Тарификация интернет трафика оплачивается дополнительно по тарифам Оператора в соответствии с вашим тарифным планом. ")])])
}]

export { render, staticRenderFns }